import React, { useEffect, useRef, useState } from 'react';
import { Pane } from '@leverege/ui-elements';
import classnames from 'classnames';
import S from './IntersectionObserverWrapper.css';
import OverflowMenu from "./OverflowMenu.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function IntersectionObserverWrapper({
  children,
  variant,
  layout,
  popupVariant,
  toggleVariant,
  adjustable = true,
  value
}) {
  const navRef = useRef(null);
  const [visibilityMap, setVisibilityMap] = useState({});
  const [menuSize, setMenuSize] = useState(0);
  const handleIntersection = entries => {
    const updatedEntries = {};
    entries.forEach(entry => {
      const targetId = entry.target.dataset.targetid;
      if (entry.isIntersecting) {
        updatedEntries[targetId] = true;
      } else {
        updatedEntries[targetId] = false;
      }
      setVisibilityMap(prev => ({
        ...prev,
        ...updatedEntries
      }));
    });
  };
  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, {
      root: navRef.current,
      rootMargin: `0px -${menuSize}px 0px 0px`,
      threshold: 1
    });
    Array.from(navRef.current.children).forEach(item => {
      if (item.dataset.targetid) {
        observer.observe(item);
      }
    });
    return () => {
      observer.disconnect();
    };
  }, [menuSize, value]);
  return /*#__PURE__*/_jsxs(Pane, {
    variant: variant,
    layout: layout,
    className: S.toolbarWrapper,
    children: [React.Children.map(children, child => {
      return /*#__PURE__*/React.cloneElement(child, {
        className: classnames(child.props.className, S.tag, {
          [S.visible]: !!visibilityMap[child.props['data-targetid']],
          [S.invisible]: !visibilityMap[child.props['data-targetid']]
        })
      });
    }), /*#__PURE__*/_jsx(Pane, {
      domRef: navRef,
      variant: variant,
      layout: layout,
      className: S.measurer,
      style: {
        width: adjustable ? undefined : 'fit-content'
      },
      children: React.Children.map(children, child => {
        return /*#__PURE__*/React.cloneElement(child, {
          className: classnames(child.props.className, S.tag)
        });
      })
    }), /*#__PURE__*/_jsx(OverflowMenu, {
      visibilityMap: visibilityMap,
      className: S.overflow,
      popupVariant: popupVariant,
      toggleVariant: toggleVariant,
      onMenuSizeChange: setMenuSize,
      value: value,
      children: children
    })]
  });
}